module.exports = __webpack_public_path__ + "static/img/xiaodu-2.850be73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaodu-2.png
// module id = dpab
// module chunks = 46